import React, { FC } from 'react';
import { Col, Collapse, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Beneficiary, BeneficiaryAccount } from '~/types';
import { TextField } from '~/components';

interface ToAccountProps {
  beneficiary: Beneficiary;
  beneficiaryAccount: BeneficiaryAccount;
  className?: string;
}

const ToAccount: FC<ToAccountProps> = (props) => {
  const { beneficiary, beneficiaryAccount, className } = props;
  // const nominatedAccount = beneficiary.nominatedAccounts[index];
  const { name, parameters } = beneficiaryAccount;

  const [t] = useTranslation('payouts');
  // const dt = (key: string): string => t(`translation:${key}`);

  return (
    <div className={`${className} ToAccount`}>
      <Typography.Title level={4}>{t('toAccount')}</Typography.Title>
      <Collapse expandIconPosition="right" defaultActiveKey={[0]}>
        <Collapse.Panel key={0} header={<div className="SendMoney-Header">{beneficiary.name}</div>}>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <TextField label={t('transferType')}>{name}</TextField>
            </Col>
            {Object.keys(parameters)?.map((paramId) => {
              const fieldValue = parameters[paramId].value;
              const fieldName = parameters[paramId].name;
              return (
                <Col span={12} key={fieldName}>
                  <TextField label={fieldName}>{fieldValue}</TextField>
                </Col>
              );
            })}
          </Row>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default styled(ToAccount)`
  /* .ToAccount-Header {
    font-size: 18px;
  } */
`;
